export default "__VITE_ASSET__BjMKW2NB__"